// Angular
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatListModule } from '@angular/material/list';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTreeModule } from '@angular/material/tree';
import { CdkTreeModule } from '@angular/cdk/tree';
import { CdkTableModule } from '@angular/cdk/table';
// NgBootstrap
import { NgbModule, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
// Core module
import { CoreModule } from '../../core/core.module';
//Markdown
import { MarkdownModule } from 'ngx-markdown';
// CRUD Partials
import { ActionNotificationComponent, AlertComponent, DeleteEntityDialogComponent, FetchEntityDialogComponent, UpdateStatusDialogComponent } from './content/crud';
// Layout partials
import {
	ContextMenu2Component,
	ContextMenuComponent,
	LanguageSelectorComponent,
	NotificationComponent,
	QuickActionComponent,
	QuickPanelComponent,
	ScrollTopComponent,
	SearchDefaultComponent,
	SearchDropdownComponent,
	SearchResultComponent,
	SplashScreenComponent,
	StickyToolbarComponent,
	Subheader1Component,
	Subheader2Component,
	Subheader3Component,
	UserProfile2Component,
	UserProfileComponent,
} from './layout';
// General
import { NoticeComponent } from './content/general/notice/notice.component';
import { PortletModule } from './content/general/portlet/portlet.module';
// Errpr
import { ErrorComponent } from './content/general/error/error.component';
// Extra module
import { ChartLoaderComponent } from './content/chart-loader/chart-loader.component';
import { SharedComponentsModule } from '../components/shared-components/shared-components.module'
import { PrimitivesModule } from '../components/primitives/primitives.module'
import { NonPrimitivesModule } from '../components/non-primitives/non-primitives.module'
// SVG inline
import { InlineSVGModule } from 'ng-inline-svg-2';
import { CartComponent } from './layout/topbar/cart/cart.component';
import { AppPipesModule } from '../pages/pipes/app-pipes.module';
import { TrainYesnoDialogComponent } from './content/crud/train-yesno-dialog/train-yesno-dialog.component';
import { AlertEntityDialogComponent } from './content/crud/alert-entity-dialog/alert-entity-dialog.component';
import { ConfirmEntityDialogComponent } from './content/crud/confirm-entity-dialog/confirm-entity-dialog.component';
import { DynamicDialogComponent } from './content/crud/dynamic-dialog/dynamic-dialog.component';
import { DeleteEntityInputPopupComponent } from './content/crud/delete-entity-input-popup/delete-entity-input-popup.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { FileBrowserComponent } from './layout/file-browser/file-browser.component';
import { FileBrowserContentComponent } from './layout/file-browser/file-browser-content/file-browser-content.component';
import { MatSelectSearchClearDirective } from 'ngx-mat-select-search/mat-select-search-clear.directive';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { FilterComponent } from './content/crud/filter/filter.component';
import { OverlayModule } from '@angular/cdk/overlay';
import { ConfirmEntityWithInputComponent } from './content/crud/confirm-entity-with-input/confirm-entity-with-input.component';
import { TimelineContentComponent } from './content/crud/timeline-content/timeline-content.component';
import { AvatarModule } from 'ngx-avatars';
import { TableComponent } from './content/crud/table/table.component';
import { MatTableExporterModule } from 'mat-table-exporter'; import { ChatbotUIComponent } from './layout/chatbot-ui/chatbot-ui.component';
import { ChatbotOpenerComponent } from './layout/chatbot-opener/chatbot-opener.component';
import { SapFilterComponent } from './content/crud/sap-filter/sap-filter.component';
import { FilterFormInputPopupComponent } from './content/crud/filter-form-input-popup/filter-form-input-popup.component';
import { BaseDialogComponent } from './content/general/base-dialog/base-dialog.component';
import { ChatSharePopupComponent } from './layout/chat-share-popup/chat-share-popup.component';
import { ChatGraphComponent } from './layout/chatbot-ui/chat-graph/chat-graph.component';
import { TranslateModule } from '@ngx-translate/core';
@NgModule({
	declarations: [
		ScrollTopComponent,
		NoticeComponent,
		ActionNotificationComponent,
		DeleteEntityDialogComponent,
		FetchEntityDialogComponent,
		UpdateStatusDialogComponent,
		AlertComponent,

		// topbar components
		ContextMenu2Component,
		ContextMenuComponent,
		QuickPanelComponent,
		ScrollTopComponent,
		SearchResultComponent,
		SplashScreenComponent,
		StickyToolbarComponent,
		Subheader1Component,
		Subheader2Component,
		Subheader3Component,
		LanguageSelectorComponent,
		NotificationComponent,
		QuickActionComponent,
		SearchDefaultComponent,
		SearchDropdownComponent,
		UserProfileComponent,
		UserProfile2Component,
		CartComponent,

		ErrorComponent,
		//Filter Reuseable component
		TrainYesnoDialogComponent,
		AlertEntityDialogComponent,
		ConfirmEntityDialogComponent,
		DynamicDialogComponent,
		DeleteEntityInputPopupComponent,
		ChatbotUIComponent,
		FileBrowserComponent,
		FileBrowserContentComponent,
		ConfirmEntityWithInputComponent,
		TimelineContentComponent,
		FilterComponent,
		SapFilterComponent,
		TableComponent,
		ChatbotOpenerComponent,
		FilterFormInputPopupComponent,
		BaseDialogComponent,
		ChatSharePopupComponent,
		ChatGraphComponent,
		ChartLoaderComponent,
	],
	exports: [
		PortletModule,
		ChartLoaderComponent,

		ScrollTopComponent,
		NoticeComponent,
		ActionNotificationComponent,
		DeleteEntityDialogComponent,
		FetchEntityDialogComponent,
		UpdateStatusDialogComponent,
		AlertComponent,
		AlertEntityDialogComponent,
		ConfirmEntityDialogComponent,
		DynamicDialogComponent,

		// topbar components
		ContextMenu2Component,
		ContextMenuComponent,
		QuickPanelComponent,
		ScrollTopComponent,
		SearchResultComponent,
		SplashScreenComponent,
		StickyToolbarComponent,
		Subheader1Component,
		Subheader2Component,
		Subheader3Component,
		LanguageSelectorComponent,
		NotificationComponent,
		QuickActionComponent,
		SearchDefaultComponent,
		SearchDropdownComponent,
		UserProfileComponent,
		UserProfile2Component,
		CartComponent,
		ChatbotUIComponent,
		ChatbotOpenerComponent,
		FileBrowserComponent,
		ErrorComponent,
		AppPipesModule,
		TimelineContentComponent,
		FilterComponent,
		SapFilterComponent,
		TableComponent,
	],
	imports: [
		CommonModule,
		DragDropModule,
		RouterModule,
		FormsModule,
		MatListModule,
		ReactiveFormsModule,
		MatFormFieldModule,
		NgbModule,
		NgbNavModule,
		InlineSVGModule,
		CoreModule,
		PortletModule,
		MatButtonModule,
		MatMenuModule,
		MatSelectModule,
		MatInputModule,
		MatTableModule,
		MatAutocompleteModule,
		MatRadioModule,
		MatIconModule,
		MatNativeDateModule,
		MatProgressBarModule,
		MatDatepickerModule,
		MatCardModule,
		MatPaginatorModule,
		MatSortModule,
		MatCheckboxModule,
		MatProgressSpinnerModule,
		MatSnackBarModule,
		MatTabsModule,
		MatTooltipModule,
		MatDialogModule,
		AppPipesModule,
		MatDividerModule,
		MatTreeModule,
		CdkTreeModule,
		MatDatepickerModule,
		NgxMatSelectSearchModule,
		OverlayModule,
		AvatarModule,
		SharedComponentsModule,
		PrimitivesModule,
		NonPrimitivesModule,
		MarkdownModule.forRoot(),
		MatTableExporterModule,
		CdkTableModule,
		TranslateModule,
	]
})
export class PartialsModule {
}
